import { StrictMode } from "react";
import { uk } from "date-fns/locale/uk";
import { createRoot } from "react-dom/client";
import ReactGA from "react-ga4";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { router } from "router";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import * as Sentry from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { queryClient } from "./api/queryClient.ts";
import ThemeProvider from "./theme/ThemeProvider";

import "./index.css";
import "react-toastify/dist/ReactToastify.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
});

ReactGA.initialize(import.meta.env.VITE_GA_ID);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={uk}>
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} />
          <ToastContainer limit={1} />
        </LocalizationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
